/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


jQuery(document).ready(function( $ ) {
    
    $('a.share-link').click(function(e){
        e.preventDefault();
        var $link   = $(this);
        var href    = $link.attr('href');
        var network = $link.attr('data-network');

        var networks = {
            facebook 	: { width : 600, height : 300 },
            twitter  	: { width : 600, height : 400 },
            pinterest	: { width : 515, height : 490 },
            linkedin 	: { width : 600, height : 473 }
        };

        var popup = function(network){
            var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
            window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width);
        }

        popup(network);
    });
    
	});

}); 